import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react"
import { cn } from "@/lib/utils"
import type { ClipSortDirection, ClipSortableColumn, ClipSortKey } from "./types"

export function ClipsListHeaderCell({
  column,
  label,
  currentSort,
  currentDirection,
  onSort,
  className,
}: {
  column: ClipSortableColumn
  label: string
  currentSort: ClipSortKey
  currentDirection: ClipSortDirection
  onSort: (column: ClipSortableColumn) => void
  className?: string
}) {
  const active = currentSort === column
  const Icon = !active ? ArrowUpDown : currentDirection === "asc" ? ArrowUp : ArrowDown

  return (
    <th className={cn("p-2", className)}>
      <button
        type="button"
        onClick={() => onSort(column)}
        className={cn(
          "inline-flex w-full cursor-pointer items-center gap-1 text-left text-xs uppercase tracking-wide transition-colors",
          active ? "text-ink-display" : "text-ink-muted hover:text-ink-display",
        )}
        aria-sort={active ? (currentDirection === "asc" ? "ascending" : "descending") : "none"}
        title={`Sort by ${label.toLowerCase()}`}
      >
        <span>{label}</span>
        <Icon className={cn("h-3 w-3 shrink-0", active ? "opacity-100" : "opacity-50")} />
      </button>
    </th>
  )
}
